import { Component, OnInit } from '@angular/core';
import { FaturamentoModel } from './faturamento.model';
import { Funcoes, Periodos } from 'src/app/services/funcoes';
import { EmpresaModel } from 'src/app/models/empresa-model';
import { ContasReceberModel } from 'src/app/models/contas-receber-model';
import { Services } from 'src/app/services/servicos';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-faturamento',
  templateUrl: './faturamento.component.html',
  styleUrls: ['./faturamento.component.css']
})
export class FaturamentoComponent implements OnInit {


  //DECLARAÇÕES
  funcoes: Funcoes = new Funcoes();
  //
  //INI VARIÁVES
  empresas: EmpresaModel[];
  selecionarEmpresa: EmpresaModel;

  origens: any[];
  selecionarOrigem: any;

  periodos: Periodos[];
  selecionarPeriodo: string;

  data_inicial: Date = new Date();
  data_final: Date = new Date();
  grafico: any;
  grafico_bar: any;

  lista: FaturamentoModel[];
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  total: number
  loading: boolean = true;
  selectedList: FaturamentoModel;
  filtros: FaturamentoModel = new FaturamentoModel();

  //A - Total 
  listaGeral: ContasReceberModel[];
  listaTotal: ContasReceberModel[];
  totalTotal: number
  displayTotal: boolean;
  //ORÇAMENTO
  listaOrcamento: ContasReceberModel[];
  totalOrcamento: number
  displayOrcamento: boolean;
  //SERVIÇOS DE CONSERVAÇÃO
  listaServicoConservacao: ContasReceberModel[];
  totalServicoConservacao: number
  displayServicoConservacao: boolean;
  //SERVIÇO
  listaServico: ContasReceberModel[];
  totalServico: number
  displayServico: boolean;
  //VENDA
  listaVenda: ContasReceberModel[];
  totalVenda: number
  displayVenda: boolean;
  //FIM VARIÁVEIS

  constructor(private service: Services,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private config: PrimeNGConfig) {

    this.periodos = this.funcoes.Periodos;
    if (this.periodos.length > 0) {
      this.selecionaMesAtual();
    }
    this.origens = this.funcoes.Origens;

    this.config.setTranslation({
      accept: 'Aceitar',
      reject: 'Cancelar',
      dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
      dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
      dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
      monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
      today: 'Hoje',
      clear: 'Limpar'
      //translations
    }); 

  }

  selecionaMesAtual() {
    var today = new Date();
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    this.selecionarPeriodo = this.periodos.find(c => c.cod == mm).nome;
    console.log(this.selecionarPeriodo);
    this.selecionaPeriodo(this.selecionarPeriodo);
  }

  ngOnInit(): void {
    //BUSCANDO EMPRESAS
    try {
      this.service.listarEmpresas()
        .subscribe(data => {
          if (data.Success) {
            this.empresas = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO EMPRESAS     
    this.selecionaMesAtual();
    //PESQUISANDO AO ABRIR
    this.pesquisar();
  }


  pesquisar() {
    this.loading = true;

    this.filtros.filtro_data_inicial = this.data_inicial;
    this.filtros.filtro_data_final = this.data_final;
    this.filtros.origem = this.selecionarOrigem == undefined ? "Receber" : this.selecionarOrigem.nome;
    this.filtros.coligada = this.selecionarEmpresa == null ? "" : this.selecionarEmpresa.nome_fantasia;
    // console.log(this.filtros);
    // console.log(this.selecionarOrigem == undefined ? "Receber" : this.selecionarOrigem.nome);
    // console.log(this.selecionarEmpresa == null ? "" : this.selecionarEmpresa.nome_fantasia);
    try {
      this.service.listarFaturamento(this.filtros)
        .subscribe(data => {
          if (data.Success) {
            this.lista = data.Response;
            this.total = this.lista.length;
            this.loading = false;
            this.updateChart(data.Response);
            // if (this.filtros.origem == "Receber") {
            //   this.updateChart(data.Response);
            // } else {
            //   this.updateChartPagar(data.Response);
            // }
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
  }

  onRowSelect(event) {

    try {
      this.service.listarFaturamentoOrigem(this.filtros)
        .subscribe(data => {
          if (data.Success) {
            this.listaGeral = data.Response;
            var today = new Date();
            if (event.data.descricaoTitulo == "A - Total") {
              this.displayTotal = true;
              this.listaTotal = this.listaGeral;
              this.totalTotal = this.listaTotal.length;
            }
            else if (event.data.descricaoTitulo == "B - Orçamentos") {
              this.displayOrcamento = true;
              this.listaOrcamento = this.listaGeral.filter(c => c.situacao == "Orçamentos" && new Date(c.aprovacao) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.aprovacao) < today);
              this.totalOrcamento = this.listaOrcamento.length;
            }
            else if (event.data.descricaoTitulo == "C - Serviços de Conservação") {
              this.displayServicoConservacao = true;
              this.listaServicoConservacao = this.listaGeral.filter(c => c.situacao == "SERVIÇOS DE CONSERVAÇÃO" && new Date(c.data) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data) < today);
              this.totalServicoConservacao = this.listaServicoConservacao.length;
            }
            else if (event.data.descricaoTitulo == "D - Serviços") {
              this.displayServico = true;
              this.listaServico = this.listaGeral.filter(c => c.situacao == "SERVIÇOS" && new Date(c.data) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data) < today);
              this.totalServico = this.listaServico.length;
            }
            else if (event.data.descricaoTitulo == "E - Vendas de Peças") {
              this.displayVenda = true;
              this.listaVenda = this.listaGeral.filter(c => c.situacao == "VENDAS DE PEÇAS" && new Date(c.data) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data) < today);
              this.totalVenda = this.listaVenda.length;
            }
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
  }

  comparandoDatasTitulosVencer(vencimento: Date) {
    var today = new Date();
    var DataVencimento = new Date(vencimento);
    // console.log(vencimento);
    // var dd = String(vencimento).padStart(2, '0');
    // var mm = String(vencimento).padStart(2, '0'); //January is 0!
    // var yyyy = vencimento;
    // console.log(dd);

    // const DataVencimento = new Date(Number(yyyy),Number(mm),Number(dd));
    console.log(DataVencimento);
    console.log(today);

    return (DataVencimento > today);
  }

  updateChart(chart: FaturamentoModel[]) {
    // console.log(chart);
    // console.log(chart[1].valor_chart);
    // console.log(chart[1].valor_chart);

    this.grafico = {
      labels: [
        'B - Orçamentos',
        'C - Serviços de Conservação',
        'D - Serviços',
        'E - Venda de Peças'],
      datasets: [
        {
          data: [chart[1].valor_nf, chart[2].valor_nf, chart[3].valor_nf, chart[4].valor_nf],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#40c764"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#40c764"
          ]
        }]
    };


    this.grafico_bar = {
      datasets: [{
        data: [
          chart[1].valor_nf, chart[2].valor_nf, chart[3].valor_nf, chart[4].valor_nf
        ],
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#40c764"
        ],
        label: 'Gráfico'
      }],
      labels: [
        'B - Orçamentos',
        'C - Serviços de Conservação',
        'D - Serviços',
        'E - Venda de Peças'
      ]
    }

  }

  updateChartPagar(chart: FaturamentoModel[]) {

    this.grafico = {
      labels: [
        'B - Orçamentos',
        'C - Serviços de Conservação',
        'D - Serviços',
        'E - Venda de Peças'],
      datasets: [
        {
          data: [chart[1].valor_nf, chart[2].valor_nf, chart[3].valor_nf, chart[4].valor_nf],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#40c764",
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#40c764",
          ]
        }]
    };
  }

  onChangePeriodo(event) {
    if (event.value != null) {
      this.selecionaPeriodo(event.value);
      console.log(event);
    }
  }

  selecionaPeriodo(mes: string) {
    console.log('LOKOOOOO' + mes);
    if (mes == "Todos") {
      this.data_inicial = new Date(1950, 1, 1);
      this.data_final = new Date();
    }
    else if (mes == "3 Meses") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 111));
      this.data_final = new Date();
      console.log((today.getDay() - 90));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "6 Meses") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 201));
      this.data_final = new Date();
      console.log((today.getDay() - 180));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "9 Meses") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 291));
      this.data_final = new Date();
      console.log((today.getDay() - 270));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "1 Ano") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 386));
      this.data_final = new Date();
      console.log((today.getDay() - 365));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "Janeiro") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 0, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Fevereiro") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 1, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Março") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 2, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Abril") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 3, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Maio") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 4, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Junho") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 5, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Julho") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 6, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Agosto") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 7, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Setembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 8, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Outubro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 9, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Novembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 10, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Dezembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 11, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
  }

}
